import { QUERY_REFETCH_INTERVALS, QUERY_STALE_TIMES } from '@/constants/query'
import { USDC_E_CONTRACT_ADDRESS, USDC_E_DECIMALS } from '@/constants/tokens'
import { useWallet } from '@/providers/WalletContext'
import { useQuery } from '@tanstack/react-query'
import { erc20Abi, formatUnits } from 'viem'

export default function usePolygonBalances(address: string | undefined) {
	const { publicClient } = useWallet()

	const {
		data: usdcBalance,
		isLoading,
		error,
		refetch,
	} = useQuery({
		queryKey: ['usdcBalance', address],
		queryFn: async () => {
			if (!(address && publicClient)) {
				return null
			}

			const balance = await publicClient.readContract({
				address: USDC_E_CONTRACT_ADDRESS,
				abi: erc20Abi,
				functionName: 'balanceOf',
				args: [address as `0x${string}`],
			})

			return balance
		},
		enabled: !!address,
		staleTime: QUERY_STALE_TIMES.BALANCE,
		refetchInterval: QUERY_REFETCH_INTERVALS.BALANCE,
		refetchIntervalInBackground: true,
		refetchOnWindowFocus: true,
	})

	const formattedUsdcBalance = usdcBalance
		? Number.parseFloat(formatUnits(usdcBalance, USDC_E_DECIMALS))
		: 0

	return {
		usdcBalance: formattedUsdcBalance,
		formattedUsdcBalance: formattedUsdcBalance.toFixed(2),
		rawUsdcBalance: usdcBalance,
		isLoading,
		isError: !!error,
		refetch,
	}
}
